import { get } from "../base.ehq.model";
import { deserialize } from "../base.serializer";

export const getParticipationConfiguration = async (
  token: string,
  baseUrl: string,
  config?: any
) => {
  try {
    const queryPath = `${baseUrl}/participation_configuration`;

    const res = await get(token, queryPath, {}, config);
    return deserialize(res);
  } catch (err) {
    throw new Error(err);
  }
};
